import LeaveHTMLPreviewBaseSection from './LeaveHTMLPreviewBaseSection'

export default function LeaveHTMLPreviewHeaderSection() {}

LeaveHTMLPreviewHeaderSection.prototype = new LeaveHTMLPreviewBaseSection();

LeaveHTMLPreviewHeaderSection.prototype.init = function( firstGroupingLevel, secondGroupingLevel, columnsStrategy )
{
    LeaveHTMLPreviewBaseSection.prototype.init.call(this, columnsStrategy);

    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    return this;
};

LeaveHTMLPreviewHeaderSection.prototype.addRows = function( tBody )
{
    let fRow = this.createRow("headerRow firstRow")
    this.addCell(
        fRow,
        ReportPreviewUtils.makeGroupingHeader(
            [   this.firstGroupingLevel,
                this.secondGroupingLevel
            ]
        ),
        "groupingLevelsTitle",
        1,
        2
    );

    this.columnsStrategy.addFirstHeaderRowCells( fRow );
    this.addRow( tBody, fRow );
    let sRow = this.createRow("headerRow secondRow")
    this.columnsStrategy.addSecondHeaderRowCells( sRow );
    this.addRow( tBody, sRow );

};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewHeaderSection.js